module.exports = __webpack_public_path__ + "img/hoel_portrett1.ed835b52.jpg";